import { render, staticRenderFns } from "./ForgotPassword-v2.vue?vue&type=template&id=ac7bd956"
import script from "./ForgotPassword-v2.vue?vue&type=script&lang=js"
export * from "./ForgotPassword-v2.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword-v2.vue?vue&type=style&index=0&id=ac7bd956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports